export enum ContractRequestRuleTypes {
    AdditionalDocuments = 19,
    CompletedContract = 21,
    PinkStipends = 24,
    AyaPaidBonus = 25
}
